<template>
  <button class="toggle" :aria-label="open ? 'Sulje valikko' : 'Avaa valikko'">
    <svg viewBox="0 0 20 14" v-if="!open">
      <line x1="0" y1="1"  x2="20" y2="1" />
      <line x1="0" y1="7"  x2="20" y2="7" />
      <line x1="0" y1="13" x2="20" y2="13" />
    </svg>
    <svg viewBox="0 0 14 14" v-else>
      <line x1="0" y1="0" x2="14" y2="14" />
      <line x1="14" y1="0" x2="0" y2="14" />
    </svg>
  </button>
</template>

<script setup>
defineProps(['open'])
</script>

<style scoped>
button {
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
}

svg {
  width: 2rem;
  height: auto;
  overflow: visible;
}

line {
  stroke: currentColor;
  stroke-width: 1px;
  stroke-linecap: round;
}
</style>
